<script setup lang="ts">
import { computed } from 'vue'

type Props = {
  equalOptions?: boolean
  useOrphansDirective?: boolean
  hideOnMobile?: boolean
  remaining?: boolean
  value: number
  label: string
  amount: number
}

type Emits = {
  amount: [value: number]
}

const props = defineProps<Props>()

const emit = defineEmits<Emits>()

const isChecked = computed(() => props.amount === props.value)
</script>

<template>
  <div
    class="type-of-support-box-option d-flex col-12 col-md-6 align-top px-0 px-md-2"
    :class="[{ 'col-12 col-md-8 col-lg-9 col-xl-7': equalOptions }]"
  >
    <div
      class="flex-wrap mb-3 px-0 col-12 align-items-start text-primary"
      v-orphans="useOrphansDirective"
      :class="hideOnMobile ? 'd-none d-md-flex' : 'd-flex'"
    >
      <div
        class="tosb-container border-blue-gray text-lg font-weight-bold typeOfSupportBoxRadio col-12 d-flex align-items-baseline"
        :class="[{ typeOfSupportBoxRadioDashed: remaining }, { 'border-blue-gray': !remaining }]"
        @click="emit('amount', value)"
      >
        <input type="radio" :id="`${value}`" :value="value" :checked="isChecked" />
        <span class="type-of-support-box-option__checkmark checkmark"></span>
        <label
          :for="`${value}`"
          class="type-of-support-box-option__label mb-0"
          v-html="label"
        ></label>
        <span
          v-if="remaining"
          class="text-sm ml-auto align-self-center mw-50 text-balance text-center"
        >
          {{ $t('donorForm.remainingOptionDescription') }}</span
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/scss/app';

.type-of-support-box-option {
  &__label {
    font-size: 1rem;

    @include media-breakpoint-up(md) {
      font-size: 1.2rem;
    }
  }

  &__checkmark {
    flex: 0 0 auto;
  }
}
</style>
